/**
 * API client functions for Repository Asset Links.
 * Handles retrieving and saving per-repository asset link configuration.
 */

import { apiClient } from '@/modules/api/api-client';

// --- Types ---

export interface RepositoryAssetLink {
  assetId: string;
  artifactIdPattern?: string;
}

// --- Repository Asset Links APIs ---

/**
 * Retrieves all repository asset links for a given repository.
 * Returns an empty array if no links exist.
 */
export async function getAssetLinks(repoName: string): Promise<RepositoryAssetLink[]> {
  return apiClient.get<RepositoryAssetLink[]>(
    `/repos/${encodeURIComponent(repoName)}/ci/asset-links`
  );
}

/**
 * Creates or updates repository asset links for a repository.
 * Replaces all existing links with the provided array.
 * Returns the saved links on success.
 * Throws ApiError with status 400 on validation failure.
 */
export async function saveAssetLinks(
  repoName: string,
  links: RepositoryAssetLink[]
): Promise<RepositoryAssetLink[]> {
  return apiClient.put<RepositoryAssetLink[]>(
    `/repos/${encodeURIComponent(repoName)}/ci/asset-links`,
    links,
    { timeout: 30_000 }
  );
}
